<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Pharmacy",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Pharmacy",
            items: [
               {
                  text: "Pharmacy",
                  href: "/pharmacies",
               },
               {
                  text: "Edit Pharmacy",
                  active: true,
               },        
            ],

            pharmacy: {
               id: "",
               name : "",
               address: "",
               mobile: "",
               email: "",
               type: 1,        
               clinic_id: null,
               
            },
            password_confirmation: '',
            password: '',

            countries: [],
            clinics: [],

            image: "",
            preview_image: "",
            pharmacy_location: "",
            pharmacy_marker: { position: { lat: '', lng: '' } },
            pharmacy_center: { lat: '', lng: '' },
            pharmacy_current_place: null,
            pharmacy_content_A: "",
            pharmacy_content_B: "",
            pharmacy_mapOptions: {
               disableDefaultUI: true,
            },
            errors: {},
            
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
         this.fetchClinics();
         this.fetchContents();
      },

      created() {
         this.fetchPharmacy();
      },

      methods: {

         fetchPharmacy(){

            let url = "api/admin/pharmacy/details?id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;

               // Use responseData.pharmacy and responseData.bookings_count
               this.pharmacy =  responseData.pharmacy;
               this.pharmacy_location = responseData.pharmacy.address || '';
               this.pharmacy_marker.position.lat = parseFloat(responseData.pharmacy.latitude);
               this.pharmacy_marker.position.lng = parseFloat(responseData.pharmacy.longitude); 


               this.pharmacy_center.lat = parseFloat(responseData.pharmacy.latitude);
               this.pharmacy_center.lng = parseFloat(responseData.pharmacy.longitude); 


               //this.PharmacyfetchPlace(pharmacy_center);

               //console.log(res.data.data);


            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));
         },

         pharmacyUpdate(){
            
            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/updatePharmacy";

            let formData = new FormData();
            formData.append("id", this.pharmacy.id);
            formData.append("name", this.pharmacy.name);
            formData.append("email", this.pharmacy.email);
            formData.append("mobile", this.pharmacy.mobile);
            formData.append("address", this.pharmacy_location);
            formData.append("country_code", this.pharmacy.country_code_id); 
            formData.append("type", this.pharmacy.type);
            if (this.pharmacy.type == 2) {
               formData.append("clinic_id", this.pharmacy.clinic_id);
            }
            formData.append("limited_tokens", this.pharmacy.limited_tokens);
            formData.append("limited_tokens_count", this.pharmacy.limited_tokens_count);
            formData.append("content_type", this.pharmacy.content_type);
            //formData.append("location", this.pharmacy.email);
            formData.append("latitude", this.pharmacy_marker.position.lat);
            formData.append("longitude", this.pharmacy_marker.position.lng);
            if(this.image) {
               formData.append('image', this.image);
            }

            this.loading = true;
            
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false))



         },

         fetchContents() {
            let url = "api/admin/getContents";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacy_content_A = responseData.contents.pharmacy_content_A;
                  this.pharmacy_content_B = responseData.contents.pharmacy_content_B;
                  console.log(this.contents);
               })
               .catch((err) => console.log(err));
         },

         changePassword(){


            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/pharmacy/change-password";
            let formData = new FormData();
            formData.append("id", this.pharmacy.id);
            formData.append("password", this.password);
            formData.append("password_confirmation", this.password_confirmation);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               this.fetchPharmacy();


         },


         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchClinics() {
              
            let url = "api/admin/tv_show/getClinics?type=" + 1;        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinics = responseData.clinics;
               })
               .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         
         //sets the position of marker when dragged
         pharmacyHandleMarkerDrag(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         pharmacyPanToMarker() {
            this.$refs.pharmacyMapRef.panTo(this.pharmacy_marker.position);
            this.$refs.pharmacyMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         pharmacyHandleMapClick(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         pharmacySetPlace(place) {
            this.pharmacy_current_place = place;
            if(this.pharmacy_current_place) {
               const marker = {
                  lat: this.pharmacy_current_place.geometry.location.lat(),
                  lng: this.pharmacy_current_place.geometry.location.lng(),
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = place.formatted_address;
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

            /*pharmacyfetchPlace(pharmacy_center) {
            if (this.pharmacy_center) {
               const marker = {
                     lat: this.pharmacy_center.lat,
                     lng: this.pharmacy_center.lng,
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = pharmacy_center.formatted_address;
            }
         },*/
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "pharmacyUpdate">
                        
                        <div class="row">
                           
                           <b-col md="12" lg="6" class="form-group">
                               <pharmacyel class="control-pharmacyel">Name Ownership<span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone</label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="pharmacy.country_code_id"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                              <b-form-input v-model="pharmacy.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                              <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           </b-col>
                           
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="pharmacy.type"
                                 name="pharmacyType"
                                 :class="{ 'is-invalid': Boolean(errors.type) }"
                                 inline
                                 >
                                 <div class="form-check-inline">
                                 <b-form-radio :value="1">Individual</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                 <b-form-radio :value="2">Under Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="pharmacy.type == 2">
                              <label class="control-label">Clinic <span class="text-danger">*</span></label>
                              <select v-model="pharmacy.clinic_id" class="form-control" :class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                <option value="">Select Clinic</option>
                                <option v-for="clinic in clinics" :key="clinic.id" :value="clinic.id">{{ clinic.name }}</option>
                              </select>
                              <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-row>
                           <b-col md="12" lg="6" class="form-group d-flex align-items-center">
                              <b-form-checkbox
                                 v-model="pharmacy.limited_tokens"
                                 name="limited_tokens"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Limited Tokens</span>
                              </b-form-checkbox>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="pharmacy.limited_tokens==1">
                              <label class="control-label">Token Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy.limited_tokens_count" v-bind:class="{ 'is-invalid': Boolean(errors.limited_tokens_count) }"></b-form-input>
                            <div v-for="(val, index) in errors.limited_tokens_count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                            <b-col md="12" class="form-group">
                              
                              <div class="row">
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': pharmacy.content_type === 1 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="pharmacy.content_type" :value="1" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content A
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ pharmacy_content_A || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': pharmacy.content_type === 2 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="pharmacy.content_type" :value="2" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content B
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ pharmacy_content_B || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <div v-for="(val, index) in errors.content_type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                    <img class="avatar-md mb-2" v-if="pharmacy.image" :src="$image_url + pharmacy.image" alt="">
                                 <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                                 <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>
                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="pharmacySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="pharmacy_location"/>
                              
                              <GmapMap v-if="pharmacy_location"
                                 :center="pharmacy_center"
                                 :zoom="18"
                                 map-style-id="pharmacy-roadmap"
                                 :options="pharmacy_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="pharmacyMapRef"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"
                                 @click="pharmacyHandleMapClick">
                                    <GmapMarker
                                       :position="pharmacy_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="pharmacyHandleMarkerDrag"
                                       @click="pharmacyPanToMarker"
                                    />
                              </GmapMap>        
                              <div v-if="errors.address" class="invalid-feedback d-block">
                                 <p class="mb-0" v-for="(val, i) in errors.address" :key="i">{{ val }}</p>
                              </div>                     
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>                        

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>

                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "changePassword">
                        <h4 class="font-size-16 mb-4">Change Password</h4>
                        <div class="row">

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
